import { getFormatter, getLastDay } from "../utils";
export class QuoteWarehouse {
    constructor(sites, insurances, lockValue, startDate) {
        this.sites = sites;
        this.insurances = insurances;
        this.lockValue = lockValue;
        this.startDate = startDate;
        this.id = null;
        this.siteId = null;
        this.sizeId = null;
        this.warehouseId = null;
        this.insuranceId = null;
        this.tax = 0.19;
        this.discount = null;
        this.months = 1;
        this.lock = false;
        this.format = getFormatter();
    }
    get site() {
        return this.sites.find(s => s.value === this.siteId);
    }
    get size() {
        if (this.site) {
            return this.site.sizes.find(s => s.value === this.sizeId);
        }
        return null;
    }
    get warehouse() {
        if (this.size) {
            return this.size.warehouses.find(w => w.value === this.warehouseId);
        }
        return null;
    }
    get insurance() {
        return this.insurances.find(i => i.value === this.insuranceId);
    }
    get monthsDiscount() {
        if (this.months > 11) {
            return .92;
        }
        else if (this.months > 5) {
            return .96;
        }
        return 1;
    }
    get price() {
        let price = 0;
        if (this.size) {
            price = this.discount && this.discount > 0 ? (this.discount * this.size.m3) : this.size.price;
        }
        return price * this.monthsDiscount;
    }
    get days() {
        return Math.min(getLastDay(this.startDate.getFullYear(), this.startDate.getMonth()).getDate(), 30);
    }
    getRemainingDays() {
        const current = this.startDate.getDate();
        return this.days - (current > 30 ? 30 : current);
    }
    get prorating() {
        const dailyPrice = this.price / this.days;
        return dailyPrice * this.getRemainingDays();
    }
    get fullMonths() {
        const current = this.startDate.getDate();
        return current >= 15 ? this.months : this.months - 1;
    }
    get baseWarehouse() {
        return this.price * this.fullMonths * this.monthsDiscount;
    }
    get totalWarehouse() {
        let total = (this.baseWarehouse) + (this.lock ? this.lockValue : 0);
        if (this.insurance) {
            total += (this.insurance.price * this.fullMonths);
        }
        return total;
    }
    get totalWarehouseNoTax() {
        let total = (this.baseWarehouse / (1 + this.tax)) + (this.lock ? (this.lockValue / (1 + this.tax)) : 0);
        if (this.insurance) {
            total += (this.insurance.price * this.fullMonths);
        }
        return total;
    }
    get totalProrating() {
        let prorating = 0;
        if (this.prorating) {
            prorating = (this.prorating * this.monthsDiscount) + (this.insurance ? this.insurance.price : 0);
        }
        return prorating;
    }
    get totalProratingNoTax() {
        let prorating = 0;
        if (this.prorating) {
            prorating = (this.prorating * this.monthsDiscount / (1 + this.tax)) + (this.insurance ? this.insurance.price : 0);
        }
        return prorating;
    }
    get total() {
        return this.totalWarehouse + this.totalProrating;
    }
    get subtotal() {
        return this.totalWarehouseNoTax + this.totalProratingNoTax;
    }
    get totalLabel() {
        return `${this.format(this.baseWarehouse)} + prorateo (${this.format(this.prorating)})`;
    }
    get m3Discount() {
        if (this.size && this.discount > 0) {
            return `${this.format(this.size.m3 * this.discount)}`;
        }
        return '- Sin descuento -';
    }
    getSummaryColumns() {
        return [
            {
                slug: 'name',
                label: `BODEGA - Sede ${this.site.label}`,
                type: 'text',
                order: false
            },
            {
                slug: 'value',
                label: 'VALOR',
                type: 'text',
                order: false
            },
        ];
    }
    getSummary() {
        const days = this.getRemainingDays();
        const proratingLabel = days === 1 ? '1 día' : `${days} días`;
        return [
            {
                slug: 'valor',
                name: `Valor de la bodega (${this.size ? this.size.m3 + 'm³' : ''})`,
                value: this.format(this.price),
            },
            {
                slug: 'prorateo',
                name: `Prorateo (${proratingLabel})`,
                value: this.format(this.totalProrating),
            },
            {
                slug: 'meses',
                name: 'Cantidad de meses',
                value: this.months
            },
            {
                slug: 'lock',
                name: 'Candado',
                value: this.lock ? `Si (${this.format(this.lockValue)})` : `No (${this.format(0)})`
            },
            {
                slug: 'seguro',
                name: 'Seguro póliza IVA incluido',
                value: this.format(this.insurance ? this.insurance.price : 0)
            }
        ];
    }
    setData(data) {
        this.id = data.id;
        this.siteId = data.siteId;
        this.sizeId = data.sizeId;
        this.warehouseId = data.warehouseId;
        this.insuranceId = data.insuranceId;
        this.discount = data.discount;
        this.months = data.months;
        this.lock = data.lock;
    }
    getJson() {
        return {
            id: this.id,
            site: this.siteId,
            size: this.sizeId,
            warehouse: this.warehouseId,
            insurance: this.insuranceId,
            discount: this.discount,
            months: this.months,
            lock: this.lock
        };
    }
}
